import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { FlexContainer } from "scmp-app/components/content/content-action-bar/styles";
import { StyledFigcaption } from "scmp-app/components/content/content-cover-image/styles";
import { ContentHeadline } from "scmp-app/components/content/content-headline";
import { StyledTopicLink } from "scmp-app/components/content/content-topic-link/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import { HomeFollowButton } from "scmp-app/components/home/follow-button";
import {
  StyledDesktopEntityFollowButton,
  StyledMobileEntityFollowButton,
} from "scmp-app/components/home/follow-button/styles";

export const StyledContentHeadline = styled(ContentHeadline)``;
export const StyledEntityLink = styled(EntityLink)`
  position: relative;

  display: block;
`;
export const StyledHomeFollowButton = styled(HomeFollowButton)`
  ${StyledMobileEntityFollowButton} {
    display: block;
  }
  ${StyledDesktopEntityFollowButton} {
    display: none;
  }
`;

export const Container = styled.div`
  display: grid;
  grid:
    "cover-image" min-content
    "content" min-content
    / 100%;
  row-gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    grid: "content cover-image" min-content;
    grid-template-columns: minmax(260px, 338px) minmax(400px, 590px);
    column-gap: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid-template-columns: minmax(220px, 336px) minmax(400px, 550px);
    column-gap: 24px;
  }
`;

export const Content = styled.div`
  grid-area: content;
`;

export const CoverImage = styled.div`
  ${StyledFigcaption} {
    display: none;

    line-height: 14px;
  }

  ${theme.breakpoints.up("tablet")} {
    ${StyledFigcaption} {
      display: block;
    }
  }
`;

export const Headline = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 8px;
  align-items: flex-start;

  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 140%;
  text-align: start;

  ${theme.breakpoints.up("tablet")} {
    font-size: 22px;
  }
`;

export const Summary = styled.div`
  margin-block-start: 12px;

  color: #6f6f6f;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 130%;
  text-align: start;
`;

export const ActionBar = styled.div`
  margin-block-start: 12px;
  ${FlexContainer} {
    color: #999999;
    font-size: 12px;
  }
`;

export const MoreOnThis = styled.div`
  display: none;

  margin-block-start: 4px;
  padding-block-start: 16px;
  border-block-start: 1px solid rgba(0, 0, 0, 0.1);

  ${theme.breakpoints.up("tablet")} {
    display: block;

    margin-block-start: 20px;
    padding-block-start: 20px;
  }

  ${StyledContentHeadline} {
    font-weight: 700;
    font-size: 15px;
    font-family: ${fontMerriweather};
    line-height: 140%;
    text-align: start;
  }
`;

export const TopicLink = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-block-start: 20px;
  padding-block-start: 9px;
  border-block-start: 1px solid #000000;

  ${theme.breakpoints.up("tablet")} {
    padding-block-start: 8px;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 9px;
  }

  ${StyledTopicLink} {
    font-weight: 700;
    font-size: 14px;
    text-align: start;
  }

  ${StyledHomeFollowButton} {
    button {
      padding-block: 2px;
      padding-inline: 4px;

      font-weight: 400;
      font-size: 12px;
      font-family: ${fontRobotoCondensed};
    }
  }
`;
